import React from 'react';

import { keyedList } from 'utils';
import { _R } from 'utils/format';

export const colored = (text, color) => <span className={`d3-color-${color}`}>{text}</span>;

export default class TooltipBuilder {
  headerLine = null;
  body = [];

  constructor(name, value) {
    if (name) this.header(name, value);
  }

  build() {
    return (
      <div>
        {this.headerLine}
        {keyedList(this.body)}
      </div>
    );
  }

  empty() {
    return this.body.length === 0;
  }

  header(name, value) {
    if (value != null) name = _R`${name}: ${colored(value, "green")}`;
    this.headerLine = <p>{colored(name, "gold")}</p>;
    return this;
  }

  line(text, bullet=true) {
    this.body.push((
      <p>
        <span className={`tooltip-icon-${bullet ? "bullet" : "nobullet"}`}/>
        {text}
      </p>
    ));
    return this;
  }

  prepend(text, bullet=true) {
    this.body.unshift((
      <p>
        <span className={`tooltip-icon-${bullet ? "bullet" : "nobullet"}`}/>
        {text}
      </p>
    ));
    return this;
  }

  add(lines) {
    if (!lines) return this;
    if (typeof lines === "string") {
      let bullet = true;
      if (lines[0] === "@") {
        lines = lines.substring(1);
        bullet = false;
      }
      this.line(lines, bullet);
    } else if (lines instanceof Array) {
      for (const line of lines) {
        this.add(line);
      }
    } else if (lines instanceof TooltipBuilder) {
      this.body.push(...lines.body);
    }
    return this;
  }
}
